import { Component, computed, input, output } from '@angular/core';

export type NavigationCardHoverColor = 'primary' | 'secondary' | 'tertiary' | (string & {});

const THEME_HOVER_COLORS: Record<string, string> = {
  primary: 'var(--mat-sys-primary)',
  secondary: 'var(--mat-sys-secondary)',
  tertiary: 'var(--mat-sys-tertiary)',
};

@Component({
  selector: 'navigation-card',
  standalone: true,
  templateUrl: './navigation-card.component.html',
  styleUrl: './navigation-card.component.scss',
  host: {
    '[style.--navigation-card-hover-color]': 'resolvedHoverColor()',
  },
})
export class NavigationCardComponent {
  /** Couleur d'accent au survol : clé du thème ('primary' | 'secondary' | 'tertiary') ou toute couleur CSS. */
  hoverColor = input<NavigationCardHoverColor>('secondary');
  disabled = input(false);

  navigate = output<MouseEvent>();

  resolvedHoverColor = computed(() => THEME_HOVER_COLORS[this.hoverColor()] ?? this.hoverColor());

  onClick(event: MouseEvent) {
    if (!this.disabled()) {
      this.navigate.emit(event);
    }
  }
}
